import { render, staticRenderFns } from "./security-setting.vue?vue&type=template&id=3a403afb&"
import script from "./security-setting.vue?vue&type=script&lang=js&"
export * from "./security-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports